import React, {useEffect, useState} from 'react';


function Register() {

    const [token, setToken] = useState('');

    // Function to set data in localStorage
    const setLocalStorageData = () => {
        localStorage.setItem('token', 'your_token_value');
        console.log('Token set in localStorage');
    };

    // Function to retrieve data from localStorage
    const getLocalStorageData = () => {
        const storedToken = localStorage.getItem('token');
        console.log('Retrieved Token:', storedToken);
        setToken(storedToken || '');
    };

    // Set data on component mount
    useEffect(() => {
        setLocalStorageData();
        getLocalStorageData();
    }, []);

    return (
        <div>
            <h1>Register</h1>

            <p>Stored Token: {token}</p>
            <button onClick={getLocalStorageData}>Get Token</button>
        </div>
    );
}

export default Register;